import React from "react";
import { useNavigate } from "react-router-dom";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import { Tooltip } from "@mui/material";
import { useSelector } from "react-redux";

import DateBar from "../DateBar/DateBar";
import NotificationBell from "../NotificationBell/NotificationBell";

const actionButtonStyle = {
  width: 40,
  height: 40,
  borderRadius: "50%",
  border: "1px solid rgba(148,163,184,0.22)",
  background: "#fff",
  color: "#0F172A",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 6px 18px rgba(15,23,42,0.08)",
  cursor: "pointer",
  transition:
    "transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease",
};

const DashboardHeaderActions = ({
  profileNode,
  showDateBar = true,
  chatPath = "/Chat_Dashboard/Chat",
  className,
  hideChatAction = false,
}) => {
  const navigate = useNavigate();
  const loginData = useSelector((state) => state.loginData.value);
  const normalizedAccessType = String(loginData?.access_type || "")
    .trim()
    .toLowerCase();
  const shouldHideChatAction =
    hideChatAction ||
    normalizedAccessType === "vendor admin" ||
    normalizedAccessType === "vendor contact";
  return (
    <div
      className={className}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        marginLeft: "auto",
        flexWrap: "wrap",
      }}
    >
      {showDateBar ? <DateBar /> : null}
      {!shouldHideChatAction ? (
        <Tooltip
          title="Chat"
          arrow
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: "1.1rem",
                padding: "0.8rem 1.1rem",
              },
            }
          }}
        >
          <div style={{ position: "relative", display: "inline-flex" }}>
            <button
              type="button"
              aria-label="Open chat"
              onClick={() => navigate(chatPath)}
              style={actionButtonStyle}
              onMouseEnter={(event) => {
                event.currentTarget.style.transform = "translateY(-1px)";
                event.currentTarget.style.boxShadow =
                  "0 10px 22px rgba(15,23,42,0.12)";
                event.currentTarget.style.borderColor = "rgba(37,99,235,0.24)";
              }}
              onMouseLeave={(event) => {
                event.currentTarget.style.transform = "translateY(0)";
                event.currentTarget.style.boxShadow =
                  "0 6px 18px rgba(15,23,42,0.08)";
                event.currentTarget.style.borderColor =
                  "rgba(148,163,184,0.22)";
              }}
            >
              <ChatBubbleOutlineRoundedIcon
                sx={{ fontSize: 22, color: "#2563EB" }}
              />
            </button>
          </div>
        </Tooltip>
      ) : null}
      <NotificationBell />
      {profileNode}
    </div>
  );
};

export default DashboardHeaderActions;
